import React from "react"
import styled from "styled-components"

import { BadgePropsType } from "./Badge.types"
import { getPrimaryColor } from "../../../style/utils"
import { styleTheme } from "../../../style/theme";


const Component: React.FC<BadgePropsType> = (props) => (
  <span className={props.className} data-color={props.color}>{props.children}</span>
)

export const Badge: React.FC<BadgePropsType> = styled(Component)`
  background: ${getPrimaryColor};
  border-radius: 4px;
  color: ${styleTheme.colors.white};
  display: inline-block;
  font-size: 12px;
  line-height: 1.5;
  padding: 2px 8px;
  text-align: center;

  &[data-color="teal"] {
    background: ${styleTheme.colors.teal.light};
    color: ${styleTheme.colors.teal.base};
  }

  &[data-color="teal-base"] {
    background: ${styleTheme.colors.teal.base};
    color: ${styleTheme.colors.white};
  }

  &[data-color="pink"] {
    background: ${styleTheme.colors.pink.light};
    color: ${styleTheme.colors.pink.base};
  }

  &[data-color="orange"] {
    background: ${styleTheme.colors.orange.light};
    color: ${styleTheme.colors.orange.base};
  }

  &[data-color="green"] {
    background: ${styleTheme.colors.green.light};
    color: ${styleTheme.colors.green.base};
  }
`